import { render } from "./VendorsIndexTable.vue?vue&type=template&id=05f8f0fe"
import script from "./VendorsIndexTable.vue?vue&type=script&lang=js"
export * from "./VendorsIndexTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__